<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import axios from 'axios';
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      total_amount: 0,
      total_paid: 0,
      filterSales:{
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: '',
        branch_id:0
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Sales Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QUANTITY',
        },
        {
          key: "SPrice_no",
          sortable: true,
          label: 'UNIT PRICE',
        },
        {
          key: "total_price",
          sortable: true,
          label: 'TOTAL PRICE',
        },
        {
          key: "sale.sale_date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "sale.receipt",
          sortable: true,
          label: "RECEIPT",
        }
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QUANTITY',
        },
        {
          key: "SPrice_no",
          sortable: true,
          label: 'UNIT PRICE',
        },
        {
          key: "total_price",
          sortable: true,
          label: 'TOTAL PRICE',
        },
        {
          key: "sale.sale_date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        }
      ],
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["filterStatus","SalesReport"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["business","branch","Branches","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.SalesReport ? this.SalesReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.SalesReport ? this.SalesReport.length : 1;
  },  
  methods: {
    ...mapActions({
      FetchSalesReport: "saledetails/fetchSalesReport",
      FetchProducts: "products/fetchProducts",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
      

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SalesReportData() {
      this.FetchSalesReport(this.filterSales);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Excel_export() {
      axios
        .post("export_sales", this.filterSales,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
  },
  updated() {
    let total_amount = 0;
      // let total_paid = 0;
      if(this.SalesReport){
        this.SalesReport.forEach((item)=>{
          total_amount = total_amount+parseInt(item.total_priceno);
        });
        this.total_amount = total_amount;
        // this.SalesReport.forEach((item)=>{
        //   total_paid = total_paid+parseInt(item.sale.paid);
        // });
        // this.total_paid = total_paid;
      }
  },
  watch: {
    SalesReport(newValue){
      if(newValue == true){
        this.SalesReportData();
      }
    }
  },
  created() {
    this.FetchSalesReport(this.filterSales);
    this.FetchProducts();
    this.SalesReportData();
    this.FetchGeneralSettings();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
      <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Sales Report from {{filterSales.datefrom}} to {{filterSales.dateto}}</h3>
              </div>
            </div> 
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>
                
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="filterSales.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="SalesReportData()"
                >
                </model-list-select>
              </div>
            </div>           
            <div class="row">
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="filterSales.datefrom"
                  class="form-control"
                  @change="SalesReportData()"
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  v-model="filterSales.dateto"
                  type="date"
                  class="form-control"
                  @change="SalesReportData()"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                
                <model-list-select
                  :list="Products ? Products : []"
                  v-model="filterSales.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="SalesReportData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
              <button class="btn btn-primary" type="button" @click="SalesReportData()">
                <span class="fa fa-filter"></span> Filter
                <b-spinner
                  v-show="filterStatus"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="SalesReport?SalesReport:[]"
                  :fields="branchid==0?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>           
              </b-table>
              <div class="row">
                  <div class="col-md-4"></div>
                  <div class="col-md-4">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeperator(total_amount)}}</span></h5>
                  </div>
                  <!-- <div class="col-md-4">
                    <h5>Total Paid: <span class="text-danger">{{thousandSeperator(total_paid)}}</span></h5>
                  </div> -->
                </div>
            </div>
            <Loader  v-if="!SalesReport"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
